<template>
  <client-only>
    <v-row align-center class="ma-0 flex-column" id="distance-calculator">
      <v-col class="question" v-show="!insertLocation">
        <p @click="openCalculator" class="mb-0 white--text">
          <v-icon right dark color="white">mdi-access-time</v-icon>
          <span class="pointer-underline subtitle-1">{{ howLongText }}</span>
        </p>
      </v-col>
      <v-col v-if="showDuration" class="duration">
        <v-icon right dark color="white" :class="'icon-forma-1-copy-11'" />
        <span @click="handleCloseCalculator">{{ duration }}</span>
      </v-col>

      <v-col
        class="distance-calculator"
        v-if="showDuration || insertLocation"
        :class="[showDuration ? 'd-none' : '']"
      >
        <div>
          <DistanceCalculator
            v-show="insertLocation"
            @closeCalculator="handleCloseCalculator"
            :isMobile="isMobile"
            @displayDuration="handleDisplayDuration"
            :address="address"
            :latitude="latitude"
            :longitude="longitude"
          />

          <p class="x-close mb-0 mt-1 ml-1">
            <span @click="handleCloseCalculator">
              <v-icon
                small
                right
                dark
                color="white"
                @click="handleCloseCalculator"
                :class="'icon-forma-1-2'"
              />
            </span>
          </p>
        </div>
      </v-col>
    </v-row>
  </client-only>
</template>

<script>
import DistanceCalculator from '@/components/Company/DistanceCalculator'

export default {
  components: {
    DistanceCalculator,
  },

  props: {
    address: {
      type: String,
    },
    latitude: {
      type: Number,
    },
    longitude: {
      type: Number,
    },
    isMobile: {
      type: Boolean,
    },
  },

  data() {
    return {
      howLongText: 'כמה זמן יקח לי להגיע לעבודה?',
      insertLocation: false,
      duration: undefined,
      showDuration: false,
    }
  },

  mounted() {
    this.showQuestion
  },

  computed: {
    showQuestion: {
      get() {
        return this.insertLocation == false && this.showDuration == false // && this.calculate == false
          ? true
          : false
      },
      set(val) {
        return val
      },
    },
  },

  methods: {
    handleDisplayDuration(duration) {
      this.showQuestion = false
      this.duration = duration
      this.showDuration = true
      this.insertLocation = false
    },

    handleCloseCalculator() {
      this.insertLocation = false
      this.showDuration = false
      this.showQuestion = true
    },

    openCalculator() {
      this.insertLocation = true
      this.showQuestion = false
    },
  },
}
</script>

<style lang="scss" scoped>
.question,
.duration {
  max-width: inherit;
}
.close-calc {
  position: relative;
  top: 10px;
  left: 5%;
}
#distance-calculator {
  position: relative;
  position: relative;
  background: $primary;
  text-align: center;
}
.distance-calculator {
  background: #3e4a54;
}
.distance-calculator-mobile {
  height: 250px;
}
.duration {
  font-size: 18px;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  background: #3e4a54;
  position: absolute;
  left: 0;
  top: 0;
}
.calculator-wrapper {
  width: 100%;
  background: $calculator-gray;
}
#description > div.calculator-wrapper > div > div {
  height: 60px;
}

@media screen and (min-width: 600px) {
  .calculator-wrapper {
    color: #ff7100;
  }
  #distance-calculator {
    height: 60px;
  }
}
@media screen and (min-width: 960px) {
  .question {
    text-align: right;
    max-width: 400px;
    margin: 0 auto;
  }
}
</style>
